module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"section.services.refer":"งานซ่อมที่ถูกส่งต่อมาให้ {name} (Refer Service)","section.services":"งานซ่อมของ {name}","see_more.label":"@:common.see_more"}}')
  delete Component.options._Ctor
}
